import {useEffect, useState} from 'react';

export const useMediaQuery = (values) => {
    const mediaMatchDefault = window.matchMedia('(max-width: 639px)');
    const mediaMatchS = window.matchMedia('(min-width: 640px) and (max-width: 767px)');
    const mediaMatchMD = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
    const mediaMatchLG = window.matchMedia('(min-width: 1024px) and (max-width: 1279px)');
    const mediaMatchXL = window.matchMedia('(min-width: 1280px) and (max-width: 1535px)');
    const mediaMatchXXL = window.matchMedia('(min-width: 1536px)');

    const [value, setValue] = useState(mediaMatchS.matches);

    const sizes = ['default','s','md','lg','xl','xxl'];

    const getValue = (size) =>{
        let actualSize;
        let sizeIndex = sizes.indexOf(size.toLowerCase());
        do{
            actualSize = values[sizes[sizeIndex]];
            sizeIndex--;
        }while(actualSize===undefined && sizeIndex>=0);

        return actualSize;
    }

    useEffect(() => {
        const handlerDefault = e => {
            if(e.matches){
                setValue(getValue('default'));
            }            
        };
        const handlerS = e => {
            if(e.matches){
                setValue(getValue('s'));
            }            
        };
        const handlerMD = e => {
            if(e.matches){
                setValue(getValue('md'));
            }
        };
        const handlerLG = e => {
            if(e.matches){
                setValue(getValue('lg'));
            }
        };
        const handlerXL = e => {
            if(e.matches){
                setValue(getValue('xl'));
            }
        };
        const handlerXXL = e => {
            if(e.matches){
                setValue(getValue('xxl'));
            }
        };
        mediaMatchDefault.addEventListener('change',handlerDefault);
        mediaMatchS.addEventListener('change',handlerS);
        mediaMatchMD.addEventListener('change',handlerMD);
        mediaMatchLG.addEventListener('change',handlerLG);
        mediaMatchXL.addEventListener('change',handlerXL);
        mediaMatchXXL.addEventListener('change',handlerXXL);

        //Init
        if(mediaMatchDefault.matches){
            setValue(getValue('default'));
        }else if(mediaMatchS.matches){
            setValue(getValue('s'));
        }else if(mediaMatchMD.matches){
            setValue(getValue('md'));
        }else if(mediaMatchLG.matches){
            setValue(getValue('lg'));
        }else if(mediaMatchXL.matches){
            setValue(getValue('xl'));
        }else if(mediaMatchXXL.matches){
            setValue(getValue('xxl'));
        }
        return () => {
            mediaMatchDefault.removeEventListener('change',handlerDefault);
            mediaMatchS.removeEventListener('change',handlerS);
            mediaMatchMD.removeEventListener('change',handlerMD);
            mediaMatchLG.removeEventListener('change',handlerLG);
            mediaMatchXL.removeEventListener('change',handlerXL);
            mediaMatchXXL.removeEventListener('change',handlerXXL);
        };
    },[]);
    return value;
};